const firstPartStepsDynamic = [
  {
    id: 0,
    name: "F2F Consultation",
    step: 0,
  },
  {
    id: 1,
    name: "Scanning",
    step: 1,
  },
  {
    id: 2,
    name: "Design",
    step: 2,
  },
];

export const isOnlinePayment = (name, progressions) => {
  // find case progress
  const caseProgress = progressions.find((p) => p.type === name);
  if (!caseProgress) {
    return false;
  }

  // find step
  const step = firstPartStepsDynamic.find((s) => s.name === name).step;
  return (
    caseProgress.termsOfPayment.paymentSchedules.find((p) => p.step === step)
      .paymentType === 0
  );
};
